import Service from '../Service';
import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import { ResponseErrorBody, RequestParamsSetupPassword } from '../../types';

export default async function(params: RequestParamsSetupPassword) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/password/validate`)
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
